/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info-circle': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M7 .333A6.67 6.67 0 00.333 7 6.669 6.669 0 007 13.666 6.669 6.669 0 0013.666 7 6.669 6.669 0 007 .333zm.666 10H6.333v-4h1.333v4zm0-5.333H6.333V3.666h1.333V5z" _fill="#A8AAAF"/>'
  }
})
